import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import Badge from "@material-ui/core/Badge";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import NotificationsIcon from "@material-ui/icons/Notifications";
import { mainListItems } from "./listitems";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import CloseIcon from "@material-ui/icons/Close";
import Dropzone from "react-dropzone";
import { storage } from "../Firebase/index";
import { v4 as uuid4 } from "uuid";
import { API_SERVICE } from '../config/URI';
import axios from 'axios';

const drawerWidth = 240;
var productImages = [];

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
  dropzone: {
    
    paddingBottom: theme.spacing(4),
    background: "#f5f5f5",
    border: "1px dashed #c2c2c2",
    borderRadius: "3px",
    textAlign: "center",
  },
}));

export default function CustomProducts({ location }) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const handleClickSnackbar = () => {
    setOpenSnackbar(true);
  };
  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };


  const [title, settitle] = React.useState("");
  const [price, setprice] = React.useState("");
  const [category, setcategory] = React.useState("");
  const [gender, setgender] = React.useState("");
  const [madein, setmadein] = React.useState("");
  const [description, setdescription] = React.useState("");
  const [productId, setproductId] = React.useState("");
  const [actualprice, setactualprice] = React.useState("");
  const [brandname, setbrandname] = React.useState("");
  const [title2, settitle2] = React.useState("");
  const [sku, setsku] = React.useState("");
  const [color, setcolor] = React.useState("");
  const [condition, setcondition] = React.useState("");
  const [itemtype, setitemtype] = React.useState("");
  const [sizeproduct, setsizeproduct] = React.useState("");
  
  const [file, setFile] = React.useState([]);
  const [file2, setFile2] = React.useState([]);
  const [file3, setFile3] = React.useState([]);
  const [file4, setFile4] = React.useState([]);
  const [message, setMessage] = React.useState("");
  const [downloadUrl, setDownloadUrl] = React.useState("");
  const [downloadUrl2, setDownloadUrl2] = React.useState("");
  const [downloadUrl3, setDownloadUrl3] = React.useState("");
  const [downloadUrl4, setDownloadUrl4] = React.useState("");

  React.useEffect(() => {
    if (file.length > 0) {
      onSubmit();
    } else {
      console.log("N");
    }
  }, [file]);

  React.useEffect(() => {
    if (file2.length > 0) {
      onSubmit2();
    } else {
      console.log("N");
    }
  }, [file2]);

  React.useEffect(() => {
    if (file3.length > 0) {
      onSubmit3();
    } else {
      console.log("N");
    }
  }, [file3]);

  React.useEffect(() => {
    if (file4.length > 0) {
      onSubmit4();
    } else {
      console.log("N");
    }
  }, [file4]);

  const onSubmit = () => {
    if (file.length > 0) {
      file.forEach((file) => {
        const timeStamp = Date.now();
        var uniquetwoKey = uuid4();
        uniquetwoKey = uniquetwoKey + timeStamp;
        const uploadTask = storage
          .ref(`returnpro/products/${uniquetwoKey}/${file.name}`)
          .put(file);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const progress = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
            handleClickSnackbar();
            setMessage(`Uploading ${progress} %`);
          },
          (error) => {
            setMessage(error);
            handleClickSnackbar();
          },
          async () => {
            // When the Storage gets Completed
            const filePath = await uploadTask.snapshot.ref.getDownloadURL();
            handleClickSnackbar();
            setMessage("File Uploaded");
            setDownloadUrl(filePath);
          }
        );
      });
    } else {
      setMessage("No File Selected Yet");
    }
  };

  const onSubmit2 = () => {
    if (file2.length > 0) {
      file2.forEach((file) => {
        const timeStamp = Date.now();
        var uniquetwoKey = uuid4();
        uniquetwoKey = uniquetwoKey + timeStamp;
        const uploadTask = storage
          .ref(`returnpro/products/${uniquetwoKey}/${file.name}`)
          .put(file);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const progress = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
            handleClickSnackbar();
            setMessage(`Uploading ${progress} %`);
          },
          (error) => {
            setMessage(error);
            handleClickSnackbar();
          },
          async () => {
            // When the Storage gets Completed
            const filePath = await uploadTask.snapshot.ref.getDownloadURL();
            handleClickSnackbar();
            setMessage("File Uploaded");
            setDownloadUrl2(filePath);
          }
        );
      });
    } else {
      setMessage("No File Selected Yet");
    }
  };



  const onSubmit3 = () => {
    if (file3.length > 0) {
      file3.forEach((file) => {
        const timeStamp = Date.now();
        var uniquetwoKey = uuid4();
        uniquetwoKey = uniquetwoKey + timeStamp;
        const uploadTask = storage
          .ref(`returnpro/products/${uniquetwoKey}/${file.name}`)
          .put(file);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const progress = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
            handleClickSnackbar();
            setMessage(`Uploading ${progress} %`);
          },
          (error) => {
            setMessage(error);
            handleClickSnackbar();
          },
          async () => {
            // When the Storage gets Completed
            const filePath = await uploadTask.snapshot.ref.getDownloadURL();
            handleClickSnackbar();
            setMessage("File Uploaded");
            setDownloadUrl3(filePath);
          }
        );
      });
    } else {
      setMessage("No File Selected Yet");
    }
  };


  const onSubmit4 = () => {
    if (file4.length > 0) {
      file4.forEach((file) => {
        const timeStamp = Date.now();
        var uniquetwoKey = uuid4();
        uniquetwoKey = uniquetwoKey + timeStamp;
        const uploadTask = storage
          .ref(`returnpro/products/${uniquetwoKey}/${file.name}`)
          .put(file);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const progress = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
            handleClickSnackbar();
            setMessage(`Uploading ${progress} %`);
          },
          (error) => {
            setMessage(error);
            handleClickSnackbar();
          },
          async () => {
            // When the Storage gets Completed
            const filePath = await uploadTask.snapshot.ref.getDownloadURL();
            handleClickSnackbar();
            setMessage("File Uploaded");
            setDownloadUrl4(filePath);
          }
        );
      });
    } else {
      setMessage("No File Selected Yet");
    }
  };
 
  

  const updateProductMainStore = () => {
    var uploadData = {
      title,
      title2,
      price: Number(price),
      displayImage: downloadUrl,
      category: itemtype.toUpperCase(),
      madein,
      gender,
      description,
      product: {
        Images: [
          downloadUrl,
          downloadUrl2,
          downloadUrl3,
          downloadUrl4
        ],
        Variants: [
          {
            Size: sizeproduct.toUpperCase()
          }
        ],
        _id: uuid4(),
        Sku: sku,
        Brand: brandname.toUpperCase(),
        Category: category.toUpperCase(),
        Color: color.toUpperCase(),
        Condition: condition,
        Description: description,
        Gender: gender.toUpperCase(),
        ListPrice: Number(price),
        MadeIn: madein,
        ParentCategory: itemtype.toUpperCase(),
        Title: title
      }
    }

    axios.post(`${API_SERVICE}/api/v1/main/addreturnproducttomainstore`, uploadData)
          .then((response) => {
              if (response.status === 200) {
                  alert("Product Added");
                  window.location.href = "/admincustomproducts";
              }
          }).catch(err => console.log(err));
  };

  const handleDrop = async (acceptedFiles) => {
    setFile(acceptedFiles.map((file) => file));
  };

  const handleDrop2 = async (acceptedFiles) => {
    setFile2(acceptedFiles.map((file) => file));
  };

  const handleDrop3 = async (acceptedFiles) => {
    setFile3(acceptedFiles.map((file) => file));
  };

  const handleDrop4 = async (acceptedFiles) => {
    setFile4(acceptedFiles.map((file) => file));
  };

  return (
    <div className={classes.root}>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        message={message}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleCloseSnackbar}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />
      
      <CssBaseline />
      <AppBar
        position="absolute"
        className={clsx(classes.appBar, open && classes.appBarShift)}
      >
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            className={clsx(
              classes.menuButton,
              open && classes.menuButtonHidden
            )}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            className={classes.title}
          >
            Dashboard
          </Typography>
          <IconButton color="inherit"></IconButton>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        open={open}
      >
        <div className={classes.toolbarIcon}>
          <IconButton onClick={handleDrawerClose}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider />
        <List>{mainListItems}</List>
      </Drawer>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid className="mt-2" container spacing={3}>
            <Grid item xs={6}>
              <TextField
                value={title}
                onChange={(e) => settitle(e.target.value)}
                id="outlined-basic"
                fullWidth
                label="Title"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={price}
                onChange={(e) => setprice(e.target.value)}
                id="outlined-basic"
                fullWidth
                label="Price"
                variant="outlined"
              />
              <p>21% VAT Inc. in Actual Price € {actualprice}</p>
            </Grid>
            <Grid item xs={12}>
              <select onChange={(e) => setbrandname(e.target.value)} class="myselect"><option>Select Your Brand</option><option value="A-COLD-WALL*">A-COLD-WALL*</option><option value="A.P.C.">A.P.C.</option><option value="ACNE STUDIOS">ACNE STUDIOS</option><option value="ADIDAS">ADIDAS</option><option value="ADIDAS Y-3 YOHJI YAMAMOTO">ADIDAS Y-3 YOHJI YAMAMOTO</option><option value="AGNONA">AGNONA</option><option value="ALBERTA FERRETTI">ALBERTA FERRETTI</option><option value="ALEXANDER MCQUEEN">ALEXANDER MCQUEEN</option><option value="ALEXANDER WANG">ALEXANDER WANG</option><option value="ALYX">ALYX</option><option value="AMBUSH">AMBUSH</option><option value="AMIRI">AMIRI</option><option value="AMMA">AMMA</option><option value="ANYA HINDMARCH">ANYA HINDMARCH</option><option value="ARC'TERYX">ARC'TERYX</option><option value="ARMANI EXCHANGE">ARMANI EXCHANGE</option><option value="ASPESI">ASPESI</option><option value="AVENUE 67">AVENUE 67</option><option value="BALENCIAGA">BALENCIAGA</option><option value="BALMAIN">BALMAIN</option><option value="BAO BAO ISSEY MIYAKE">BAO BAO ISSEY MIYAKE</option><option value="BARROW">BARROW</option><option value="BILLIONAIRE BOYS CLUB">BILLIONAIRE BOYS CLUB</option><option value="BORBONESE">BORBONESE</option><option value="BOTTEGA VENETA">BOTTEGA VENETA</option><option value="BOYY">BOYY</option><option value="BRUNELLO CUCINELLI">BRUNELLO CUCINELLI</option><option value="BULGARI">BULGARI</option><option value="BURBERRY">BURBERRY</option><option value="BY FAR">BY FAR</option><option value="CALVIN KLEIN">CALVIN KLEIN</option><option value="CARDITOSALE">CARDITOSALE</option><option value="CARHARTT">CARHARTT</option><option value="CHIARA FERRAGNI">CHIARA FERRAGNI</option><option value="CHINATOWN MARKET">CHINATOWN MARKET</option><option value="CHLOÉ">CHLOÉ</option><option value="CHRISTIAN LOUBOUTIN">CHRISTIAN LOUBOUTIN</option><option value="COACH">COACH</option><option value="COCCINELLE">COCCINELLE</option><option value="COMME DES GARÇONS">COMME DES GARÇONS</option><option value="COMME DES GARÇONS SHIRT">COMME DES GARÇONS SHIRT</option><option value="CP COMPANY">CP COMPANY</option><option value="CULT GAIA">CULT GAIA</option><option value="CÉLINE">CÉLINE</option><option value="DANSE LENTE">DANSE LENTE</option><option value="DESIGUAL">DESIGUAL</option><option value="DIESEL RED TAG">DIESEL RED TAG</option><option value="DIOR">DIOR</option><option value="DOLCE E GABBANA">DOLCE E GABBANA</option><option value="DRKSHDW BY RICK OWENS">DRKSHDW BY RICK OWENS</option><option value="DSQUARED2">DSQUARED2</option><option value="EASTPAK">EASTPAK</option><option value="ELISABETTA FRANCHI">ELISABETTA FRANCHI</option><option value="EMPORIO ARMANI">EMPORIO ARMANI</option><option value="ERMANNO SCERVINO">ERMANNO SCERVINO</option><option value="ETRO">ETRO</option><option value="F**K">F**K</option><option value="FABIANA FILIPPI">FABIANA FILIPPI</option><option value="FAY">FAY</option><option value="FENDI">FENDI</option><option value="FILA">FILA</option><option value="FURLA">FURLA</option><option value="GANNI">GANNI</option><option value="GANT">GANT</option><option value="GCDS">GCDS</option><option value="GEDEBE">GEDEBE</option><option value="GIAMBATTISTA VALLI">GIAMBATTISTA VALLI</option><option value="GIORGIO BRATO">GIORGIO BRATO</option><option value="GIUSEPPE ZANOTTI DESIGN">GIUSEPPE ZANOTTI DESIGN</option><option value="GIVENCHY">GIVENCHY</option><option value="GOLDEN GOOSE">GOLDEN GOOSE</option><option value="GUCCI">GUCCI</option><option value="GUESS">GUESS</option><option value="GUM">GUM</option><option value="HERON PRESTON">HERON PRESTON</option><option value="HOGAN">HOGAN</option><option value="ISABEL MARANT">ISABEL MARANT</option><option value="ISABEL MARANT ÉTOILE">ISABEL MARANT ÉTOILE</option><option value="J.W. ANDERSON">J.W. ANDERSON</option><option value="JACQUEMUS">JACQUEMUS</option><option value="JIL SANDER">JIL SANDER</option><option value="JIMMY CHOO">JIMMY CHOO</option><option value="JUNYA WATANABE">JUNYA WATANABE</option><option value="K-WAY">K-WAY</option><option value="KARL LAGERFELD">KARL LAGERFELD</option><option value="KENZO">KENZO</option><option value="KITON">KITON</option><option value="L'AUTRE CHOSE">L'AUTRE CHOSE</option><option value="LACOSTE">LACOSTE</option><option value="LANCASTER PARIS">LANCASTER PARIS</option><option value="LANVIN">LANVIN</option><option value="LEMAIRE">LEMAIRE</option><option value="LES PETITS JOUEURS">LES PETITS JOUEURS</option><option value="LEVI'S">LEVI'S</option><option value="LIU JO">LIU JO</option><option value="LOEWE">LOEWE</option><option value="LONGCHAMP">LONGCHAMP</option><option value="LOVE MOSCHINO">LOVE MOSCHINO</option><option value="MAISON KITSUNÉ">MAISON KITSUNÉ</option><option value="MAISON MARGIELA">MAISON MARGIELA</option><option value="MAMMUT">MAMMUT</option><option value="MANILA GRACE">MANILA GRACE</option><option value="MANSUR GAVRIEL">MANSUR GAVRIEL</option><option value="MANU ATELIER">MANU ATELIER</option><option value="MARC JACOBS">MARC JACOBS</option><option value="MARCELO BURLON">MARCELO BURLON</option><option value="MARINE SERRE">MARINE SERRE</option><option value="MARNI">MARNI</option><option value="MARSELL">MARSELL</option><option value="MC2 SAINT BARTH">MC2 SAINT BARTH</option><option value="MCM">MCM</option><option value="MCQ BY ALEXANDER MCQUEEN">MCQ BY ALEXANDER MCQUEEN</option><option value="MICHAEL KORS">MICHAEL KORS</option><option value="MIU MIU">MIU MIU</option><option value="MONCLER">MONCLER</option><option value="MOSCHINO">MOSCHINO</option><option value="MSGM">MSGM</option><option value="MULBERRY">MULBERRY</option><option value="MY TWIN">MY TWIN</option><option value="NANUSHKA">NANUSHKA</option><option value="NEIL BARRETT">NEIL BARRETT</option><option value="NENETTE">NENETTE</option><option value="N°21">N°21</option><option value="OFF-WHITE">OFF-WHITE</option><option value="OPENING CEREMONY">OPENING CEREMONY</option><option value="ORCIANI">ORCIANI</option><option value="PACO RABANNE">PACO RABANNE</option><option value="PALM ANGELS">PALM ANGELS</option><option value="PATAGONIA">PATAGONIA</option><option value="PATRIZIA PEPE">PATRIZIA PEPE</option><option value="PAUL SMITH">PAUL SMITH</option><option value="PAULA CADEMARTORI">PAULA CADEMARTORI</option><option value="PHILIPP PLEIN">PHILIPP PLEIN</option><option value="PHILIPPE MODEL">PHILIPPE MODEL</option><option value="PINK MEMORIES">PINK MEMORIES</option><option value="PINKO">PINKO</option><option value="PIQUADRO">PIQUADRO</option><option value="PRADA">PRADA</option><option value="PROENZA SCHOULER">PROENZA SCHOULER</option><option value="PS BY PAUL SMITH">PS BY PAUL SMITH</option><option value="PYREX">PYREX</option><option value="RAF SIMONS">RAF SIMONS</option><option value="RALPH LAUREN">RALPH LAUREN</option><option value="REBECCA MINKOFF">REBECCA MINKOFF</option><option value="RED VALENTINO">RED VALENTINO</option><option value="REE PROJECTS">REE PROJECTS</option><option value="RICK OWENS">RICK OWENS</option><option value="RINASCIMENTO">RINASCIMENTO</option><option value="ROBERTA DI CAMERINO">ROBERTA DI CAMERINO</option><option value="ROBERTO FESTA">ROBERTO FESTA</option><option value="RODO">RODO</option><option value="SACAI">SACAI</option><option value="SAINT LAURENT">SAINT LAURENT</option><option value="SALAR">SALAR</option><option value="SALVATORE FERRAGAMO">SALVATORE FERRAGAMO</option><option value="SARA BATTAGLIA">SARA BATTAGLIA</option><option value="SEE BY CHLOÉ">SEE BY CHLOÉ</option><option value="SEVENTY">SEVENTY</option><option value="SIMON MILLER">SIMON MILLER</option><option value="SIMONETTA RAVIZZA">SIMONETTA RAVIZZA</option><option value="SPRAYGROUND">SPRAYGROUND</option><option value="STAND">STAND</option><option value="STAUD CLOTHING">STAUD CLOTHING</option><option value="STELLA MCCARTNEY">STELLA MCCARTNEY</option><option value="STONE ISLAND">STONE ISLAND</option><option value="STUSSY">STUSSY</option><option value="SUN 68">SUN 68</option><option value="SUNNEI">SUNNEI</option><option value="THE ATTICO">THE ATTICO</option><option value="THE NORTH FACE">THE NORTH FACE</option><option value="THEMOIRÈ">THEMOIRÈ</option><option value="THOM BROWNE">THOM BROWNE</option><option value="TOD'S">TOD'S</option><option value="TOM FORD">TOM FORD</option><option value="TOMMY HILFIGER">TOMMY HILFIGER</option><option value="TORY BURCH">TORY BURCH</option><option value="TOSCA BLU">TOSCA BLU</option><option value="TUBICI">TUBICI</option><option value="TWENTY FOURHAITCH">TWENTY FOURHAITCH</option><option value="TWIN-SET">TWIN-SET</option><option value="UNDERCOVER">UNDERCOVER</option><option value="VALENTINO">VALENTINO</option><option value="VALENTINO GARAVANI">VALENTINO GARAVANI</option><option value="VERSACE">VERSACE</option><option value="VERSACE JEANS">VERSACE JEANS</option><option value="VICTORIA BECKHAM">VICTORIA BECKHAM</option><option value="VIVIENNE WESTWOOD">VIVIENNE WESTWOOD</option><option value="WANDLER">WANDLER</option><option value="Y/PROJECT">Y/PROJECT</option><option value="YNOT?">YNOT?</option><option value="YUZEFI">YUZEFI</option><option value="ZANELLATO">ZANELLATO</option></select>
            </Grid>
            <Grid item xs={12}>
              <TextField
                value={title2}
                onChange={(e) => settitle2(e.target.value)}
                id="outlined-basic"
                fullWidth
                label="Title 2"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
            <select onChange={(e) => setcategory(e.target.value)} class="myselect"><option disabled="">-- CATEGORY --</option><option value="SHOW ALL">SHOW ALL</option><option value="TOTE">TOTE</option><option value="HANDBAG">HANDBAG</option><option value="SHOULDER BAG">SHOULDER BAG</option><option value="POUCH">POUCH</option><option value="BACKPACK">BACKPACK</option><option value="TRAVEL BAG">TRAVEL BAG</option><option value="BELT BAG">BELT BAG</option><option value="BEAUTY CASE">BEAUTY CASE</option><option value="CLUTCH">CLUTCH</option><option value="TROLLEY">TROLLEY</option><option value="BRIEFCASE">BRIEFCASE</option></select>
            </Grid>

            <Grid item xs={6}>
              <TextField
                value={gender}
                onChange={(e) => setgender(e.target.value)}
                id="outlined-basic"
                fullWidth
                label="Gender (F/M)"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                value={sku}
                onChange={(e) => setsku(e.target.value)}
                id="outlined-basic"
                fullWidth
                label="SKU Number"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                value={color}
                onChange={(e) => setcolor(e.target.value)}
                id="outlined-basic"
                fullWidth
                label="Color (Blue)"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                value={condition}
                onChange={(e) => setcondition(e.target.value)}
                id="outlined-basic"
                fullWidth
                label="Condition (New In)"
                variant="outlined"
              />
            </Grid>


            <Grid item xs={12}>
              <TextField
                value={madein}
                onChange={(e) => setmadein(e.target.value)}
                id="outlined-basic"
                fullWidth
                label="Made In (Italy)"
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                value={sizeproduct}
                onChange={(e) => setsizeproduct(e.target.value)}
                id="outlined-basic"
                fullWidth
                label="Size (UNI)"
                variant="outlined"
              />
            </Grid>
          
            <Grid item xs={6}>
            <select onChange={(e) => setitemtype(e.target.value)} class="myselect"><option disabled="">-- TYPE --</option><option value="BAGS">BAGS</option><option value="ACCESSORIES">ACCESSORIES</option></select>
            </Grid>

            <Grid item xs={12}>
              <TextField
                id="outlined-multiline-static"
                label="Description"
                multiline
                rows={8}
                value={description}
                variant="outlined"
                fullWidth
                onChange={(e) => setdescription(e.target.value)}
              />
            </Grid>


            <Grid item xs={12}>
              <Dropzone onDrop={handleDrop}>
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps({ className: "dropzone" })}>
                    <input {...getInputProps()} />
                    <Button size="large" color="primary" variant="outlined">
                      Upload Image 1*
                    </Button>
                  </div>
                )}
              </Dropzone>
            </Grid>

            <Grid item xs={12}>
              <Dropzone onDrop={handleDrop2}>
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps({ className: "dropzone" })}>
                    <input {...getInputProps()} />
                    <Button size="large" color="primary" variant="outlined">
                      Upload Image 2*
                    </Button>
                  </div>
                )}
              </Dropzone>
            </Grid>

            <Grid item xs={12}>
              <Dropzone onDrop={handleDrop3}>
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps({ className: "dropzone" })}>
                    <input {...getInputProps()} />
                    <Button size="large" color="primary" variant="outlined">
                      Upload Image 3*
                    </Button>
                  </div>
                )}
              </Dropzone>
            </Grid>

            <Grid item xs={12}>
              <Dropzone onDrop={handleDrop4}>
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps({ className: "dropzone" })}>
                    <input {...getInputProps()} />
                    <Button size="large" color="primary" variant="outlined">
                      Upload Image 4*
                    </Button>
                  </div>
                )}
              </Dropzone>
            </Grid>


        

       
          </Grid>


    

          <Button
            onClick={updateProductMainStore}
            className="mt-2"
            fullWidth
            size="large"
            variant="contained"
            color="primary"
          >
            Submit
          </Button>
        </Container>
      </main>
    </div>
  );
}
